module.exports = __webpack_public_path__ + "static/media/feature-private2.638a4ab1.png";